<script lang="ts" setup>
import { ref, onMounted } from "vue";

const props = defineProps({
  dataList: {
    type: Array<any>,
    default: [],
  },
  disabled: {
    type: Boolean,
    required: false,
  },
});

const { dataList, disabled } = toRefs(props);

const arrayList = ref<any[]>([]);
const typeList = ref<any>({
  theme: "主题",
  headline: "标题",
  nodule: "节点",
});

onMounted(() => {
  arrayList.value = dataList.value;
});
</script>

<template>
  <div>
    <div
      class="node-li"
      v-for="(item, index) in arrayList.filter((item) => item.title)"
      :key="index"
    >
      <div class="node-Name">
        <div class="node-line" v-if="item.type != 'theme'"></div>
        <div
          class="node-circle"
          :style="{
            'background-color': item.type ? '#bfbfbf' : 'transition',
          }"
        ></div>
        <div class="node-type">
          {{ item.type ? typeList[item.type] : "子项" }}
        </div>
        <el-input
          v-model="item.title"
          :clearable="false"
          :disabled="disabled"
        ></el-input>
      </div>

      <div class="node-ul-parent">
        <div class="node-ul relative">
          <div class="border absolute"></div>
          <treeNode
            :dataList="item.children"
            :disabled="disabled"
            v-if="item.children && item.children.length > 0"
          ></treeNode>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.node-ul-parent {
  .node-ul {
    .border {
      height: 100%;
      width: 1px;
      background-color: #bfbfbf;
      transform: translateY(-14px);
    }
  }
}

.node-ul {
  margin-left: 30px;
}

.node-li {
  list-style: none;
  position: relative;
  margin: 10px 0;

  .node-Name {
    height: 60rpx;
    line-height: 60rpx;
    border-radius: 15rpx;
    white-space: nowrap;
    display: flex;
    align-items: center;

    .node-line {
      width: 26px;
      height: 1px;
      background-color: #bfbfbf;
    }

    .node-circle {
      width: 10px;
      height: 10px;
      border: 1px solid #bfbfbf;
      border-radius: 5px;
      margin-right: 5px;
    }

    .node-type {
      display: flex;
      align-items: center;
      justify-content: center;
      border: #007aff solid 1px;
      width: 40px;
      height: 22px;
      border-radius: 5px;
      color: #007aff;
      margin-right: 5px;
      font-size: 12px;
    }

    .outline-input {
      &:focus-within {
        border-color: #007aff99 !important;
      }
    }
  }
}
</style>
